import { postRawRequest } from '../../httpClient';
import type { IExtractSubtitleV1Params } from './extract-subtitle-v1-request';

const ONE_HOUR_MS = 3_600_000;

export async function extractSubtitleV1Api({
  subtitleId,
  testRun,
  force,
}: IExtractSubtitleV1Params): Promise<Response> {
  const params: string[] = [];
  if (testRun) {
    params.push('testRun=true');
  }
  if (force) {
    params.push('force=true');
  }
  const query = params.length > 0 ? `?${params.join('&')}` : '';
  return postRawRequest({
    path: `/sys/subtitles/${subtitleId}/extract/v1${query}`,
    options: { timeout: ONE_HOUR_MS },
  });
}
